export default __webpack_public_path__ + "static/media/logo.84c9ec43.png";